interface MapLogoProps {
  fill: string;
}

/* §FB47: іконка вкладки «Карта WordCraft» — шпилька на контурі карти. */
const MapLogo = ({ fill }: MapLogoProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 15.55 2.7 17.27a.9.9 0 0 1-1.2-.84V4.9a.9.9 0 0 1 .57-.84L7 2.3v13.25Zm1.5.06V2.36l3-.02v5.42a4.9 4.9 0 0 0 1.5 2.99v4.9l-4.5-.04Zm9.43-13.36a.9.9 0 0 1 .57.84v11.53a.9.9 0 0 1-.57.84l-2.93 1.17v-5.2c.9-1.01 1.5-2.1 1.5-3.63V2.02l1.43.23Z"
      fill={fill}
      opacity="0.45"
    />
    <path
      d="M14.5 1.5a3.3 3.3 0 0 0-3.3 3.3c0 2.32 2.72 5.06 3.02 5.36a.4.4 0 0 0 .56 0c.3-.3 3.02-3.04 3.02-5.36a3.3 3.3 0 0 0-3.3-3.3Zm0 4.6a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6Z"
      fill={fill}
    />
  </svg>
);

export default MapLogo;
